export const WEB_ROUTES = {
  ACCOUNT: "/account",
  CREATE_ROUTE: "/create-route",
  EDIT_ROUTE: (id: string | number = ":id") => `/edit-route/${id}`,
  HOME: "/home",
  ROUTES: "/routes",
  DRIVERS: "/drivers",
  ADD_DRIVERS: "/add-driver",
  CHAT: "/chat",
  HISTORY: "/history",
  SETTING: "/settings",
  ROUTE_TRACKING: (id: string | number = ":id") => "/route-tracking/" + id,
  ROUTE_DETAIL: (id: string | number = ":id") => `/route-detail/${id}`,
  DRIVER_PROFILE: (id: string | number = ":id") => "/driver-profile/" + id,
  EDIT_PROFILE: "/edit-profile",
  CHANGE_PASSWORD: "/change-password",
};

export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 991,
  DESKTOP: 1200,
};

export const ROUTE_STOP_STATUS = {
  PICKEDUP: "PICKED UP",
  NOTPICKED: "NOT PICKED",
  INCOMPLETESTOP: "INCOMPLETE STOP",
  ONTIMEPICKUP: "ON TIME PICKUP",
  STOPPED: "STOPPED",
};

export const ROUTE_STATUS = {
  PENDING: "STOPPED",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
};

export const EMERGENCY_STOPS_TYPES = {
  GPS: "GPS",
  NOTES: "NOTES",
  OPENCAMERA: "OPEN CAMERA",
};

export const EMERGENCY_SERVICE = {
  FUELSTOP: "FUEL STOP",
  DUMPRUN: "DUMP RUN",
  BREAKDOWN: "BREAK DOWN",
  PERSONAL: "PERSONAL",
};


export const ROUTE_STOP_IMAGES = {
  [ROUTE_STOP_STATUS.PICKEDUP]: "/images/marker/blue.png",
  [ROUTE_STOP_STATUS.NOTPICKED]: "/images/marker/green.png",
  [ROUTE_STOP_STATUS.INCOMPLETESTOP]: "/images/marker/yellow.png",
  [ROUTE_STOP_STATUS.ONTIMEPICKUP]: "/images/marker/purple.png",
  [ROUTE_STOP_STATUS.STOPPED]: "/images/marker/red.png",
  'default': "/images/marker/red.png",
}